import { useState, useEffect } from 'react';
import { TimeSpan } from '../../types';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { chartIntervalSelector } from '@src/store/trends/birdChart/selectors';

export const useInterval = ({ defaultInterval }) => {
  const [timeSpan, setTimeSpan] = useState<TimeSpan>({ from: '', to: '', shortcut: 'custom' });
  const [interval, setInterval] = useState<string>('');
  const chartInterval = useSelector(chartIntervalSelector);

  useEffect(() => {
    if (defaultInterval) {
      const [from, to] = defaultInterval.split('/').map((x) => moment(x));
      setTimeSpan({
        from: from.format(),
        to: to.format(),
        shortcut: 'custom',
      });
      setInterval(defaultInterval);
      return;
    }
    // if no defaultInterval, use Trends interval as default
    let { from, to } = chartInterval;
    if (from && to) {
      from = moment(from).format();
      to = moment(to).format();
      setTimeSpan({
        from,
        to,
        shortcut: 'custom',
      });
      setInterval(`${from}/${to}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDateChange = (obj) => {
    const { from, to } = obj;
    setTimeSpan(obj);
    setInterval(`${from}/${to}`);
  };

  return {
    interval,
    timeSpan,
    handleDateChange,
  };
};
